<template>
  <div class="groupMain">
    <!-- <img class="groupLogo" src="@/assets/images/mall/car-group.png"/> -->
    <div class="title">{{ title }}</div>
    <div class="groupCar">
      <div class="groupList" v-for="item in carList" :key="item.id" @click="adRoute(item)">
        <div v-if="item.id" class="group-info">
          <!-- 标题 -->
          <p class="groupName">
            <span v-if="item.activityItemInfoDto && item.activityItemInfoDto.activityInfoDto">{{
              item.activityItemInfoDto.activityInfoDto.activityTag
            }}</span
            >{{ item.name }}
          </p>
          <!-- 主图 -->
          <div class="img">
            <img :src="item.mainImage" alt="" />
          </div>
          <!-- 进度条 -->
          <div class="progress-bar">
            <div class="progress-top">
              <span class="progress-text" v-if="now < item.activityItemInfoDto.activityInfoDto.realStartTime"
                >未开始</span
              >
              <span class="progress-text-begin" v-else>{{
                item.activityItemInfoDto.ifDisplayDiscounts ? '已优惠' : ''
              }}</span>
              <span
                class="progress-text"
                v-for="elm in item.activityItemInfoDto.groupPurchaseLadderDto.ladder"
                :key="elm.ladderNo"
                style="text-align:right"
                >{{
                  item.activityItemInfoDto && item.activityItemInfoDto && item.activityItemInfoDto.ifDisplayDiscounts
                    ? '￥' + elm.favorablePrice / 100
                    : ''
                }}</span
              >
              <!-- 占位 -->
              <span class="progress-text" v-if="item.activityItemInfoDto.ifDisplayDiscounts == false"></span>
            </div>
            <div class="progress-center">
              <el-progress
                :color="customColorMethod"
                :show-text="false"
                :stroke-width="12"
                :percentage="groupRate(item)"
                :show-pivot="false"
                :stroke-linecap="'square'"
              ></el-progress>
              <div
                class="white-line"
                v-if="
                  item.activityItemInfoDto.groupPurchaseLadderDto.ladder &&
                    item.activityItemInfoDto.groupPurchaseLadderDto.ladder.length > 1
                "
              ></div>
            </div>
            <div class="progress-bottom">
              <span class="progress-text">还差</span>
              <span
                class="progress-text"
                v-for="elm in item.activityItemInfoDto.groupPurchaseLadderDto.ladder"
                :key="elm.ladderNo"
                style="text-align:right"
                >{{
                  item.activityItemInfoDto.activityInfoDto.id == '1283753320908849152' ||
                  item.activityItemInfoDto.activityInfoDto.id == '1283744971492425728' ||
                  item.activityItemInfoDto.activityInfoDto.id == '1308247897355059200'
                    ? 0
                    : elm.needNum
                }}人</span
              >
            </div>
            <!-- <span class="progress-text">400人</span></div -->
          </div>
          <!-- 底部按钮 -->
          <div class="content-bottom">
            <div class="group-num">
              <div v-if="now < item.activityItemInfoDto.activityInfoDto.realStartTime" class="group-info">
                <span class="date-red">{{ dateFormat(item.activityItemInfoDto.activityInfoDto.realStartTime) }}</span
                >开团
              </div>
              <div v-else class="group-info">
                <span class="person-red">{{
                  item.activityItemInfoDto.activityInfoDto.id == '1283753320908849152' ||
                  item.activityItemInfoDto.activityInfoDto.id == '1283744971492425728' ||
                  item.activityItemInfoDto.activityInfoDto.id == '1308247897355059200'
                    ? item.activityItemInfoDto.groupPurchaseLadderDto.joinNum + 200
                    : item.activityItemInfoDto.groupPurchaseLadderDto.joinNum
                }}</span
                >人已团
              </div>
            </div>

            <div class="grounp-btn" @click="adRoute(item)">立即参团</div>
          </div>
        </div>
        <div class="onlyProductImage" v-else>
          <img class="selection-img" :src="item.mainImage" mode="aspectFit" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Progress } from 'element-ui'

import { getNetTime } from '@/lib/utils'
import moment from 'moment'

export default {
  name: '',
  data() {
    return {
      groCarList: [],
      now: '',
      carList: []
    }
  },
  props: {
    groupCarList: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      title: '整车团购'
    }
  },
  components: {
    ElProgress: Progress
  },
  methods: {
    // isNumShow(joinNumber,ladderDtoList){
    //   const quantity = ladderDtoList[ladderDtoList.length - 1].quantity
    //   if(quantity-joinNumber>0){
    //     return true
    //   }else{
    //     return false
    //   }
    // },
    filterActivity() {
      this.groupCarList.itemList.map((res) => {
        if (
          res.activityItemInfoDto &&
          res.activityItemInfoDto.activityInfoDto &&
          res.activityItemInfoDto.groupPurchaseLadderDto
        ) {
          this.carList.push(res)
        }
      })
    },
    dateFormat(date) {
      if (!date) return ''
      return moment(date).format('YYYY-MM-DD')
    },
    // 改变进度条的颜色
    customColorMethod(percentage) {
      if (percentage <= 50) {
        return '#F7442A'
      } else {
        return '#C6001F'
      }
    },
    // 进度条百分比计算
    groupRate(item) {
      // fakerData
      if (
        item.activityItemInfoDto.activityInfoDto.id === '1283753320908849152' ||
        item.activityItemInfoDto.activityInfoDto.id === '1283744971492425728' ||
        item.activityItemInfoDto.activityInfoDto.id === '1308247897355059200'
      ) {
        return 100
      }
      // 只有一个阶梯的时候
      if (item.activityItemInfoDto.groupPurchaseLadderDto.ladder.length === 1) {
        let current = item.activityItemInfoDto.groupPurchaseLadderDto.joinNum
        let all = item.activityItemInfoDto.groupPurchaseLadderDto.ladder[0].participantNum
        if (!current || !all) {
          return 0
        }
        if (current >= all) {
          return 100
        } else if (current <= 0) {
          return 0
        } else {
          return parseInt((current / all) * 100)
        }
      } else if (item.activityItemInfoDto.groupPurchaseLadderDto.ladder.length === 2) {
        // 第一阶梯
        if (
          item.activityItemInfoDto.groupPurchaseLadderDto.joinNum <
          item.activityItemInfoDto.groupPurchaseLadderDto.ladder[0].participantNum
        ) {
          let current = item.activityItemInfoDto.groupPurchaseLadderDto.joinNum
          let all = item.activityItemInfoDto.groupPurchaseLadderDto.ladder[0].participantNum
          if (!current || !all) {
            return 0
          }
          if (current >= all) {
            return 100 * 0.5
          } else if (current <= 0) {
            return 0
          } else {
            return parseInt((current / all) * 100 * 0.5)
          }
        } else {
          // 第二阶梯
          let current =
            item.activityItemInfoDto.groupPurchaseLadderDto.joinNum -
            item.activityItemInfoDto.groupPurchaseLadderDto.ladder[0].participantNum
          let all =
            item.activityItemInfoDto.groupPurchaseLadderDto.ladder[1].participantNum -
            item.activityItemInfoDto.groupPurchaseLadderDto.ladder[0].participantNum
          if (!current || !all) {
            return 0 + 50
          }
          if (current >= all) {
            return 100
          } else if (current <= 0) {
            return 0 + 50
          } else {
            return parseInt((current / all) * 100 * 0.5 + 50)
          }
        }
      }
    },
    // 点击进入详情页
    adRoute(item) {
      let url = ''
      if (item.type === '0' || item.type === 0) {
        if (
          item.activityItemInfoDto &&
          item.activityItemInfoDto.activityInfoDto &&
          item.activityItemInfoDto.activityInfoDto.id
        ) {
          url = `/details/allCars?activityId=${item.activityItemInfoDto.activityInfoDto.id}&id=${item.id}`
        } else {
          url = `/details/allCars?id=${item.id}`
        }
      } else {
        if (
          item.activityItemInfoDto &&
          item.activityItemInfoDto.activityInfoDto &&
          item.activityItemInfoDto.activityInfoDto.id
        ) {
          url = `/details/boutiqueAccessories?activityId=${item.activityItemInfoDto.activityInfoDto.id}&id=${item.id}`
        } else {
          url = `/details/boutiqueAccessories?id=${item.id}`
        }
      }
      this.$router.push(url)
    },
    timeFormat(startTime, endTime) {
      let currentTime = getNetTime()
      if (currentTime < startTime) {
        return 0
      } else if (currentTime > endTime) {
        return 2
      } else {
        return 1
      }
    },
    doingSpan(current, all) {
      let mark = -1
      let list = all.length - 1
      for (list; list >= 0; list--) {
        if (parseInt(current) >= parseInt(all[list].quantity)) {
          if (!current || !all[list].quantity) return
          mark++
        }
      }
      return mark
    },
    toChinesNum(num) {
      // 千级别转换大写
      let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      let unit = ['', '十', '百', '千']
      num = parseInt(num)
      let getWan = (temp) => {
        let strArr = temp
          .toString()
          .split('')
          .reverse()
        let newNum = ''
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i === 0 && strArr[i] === 0
              ? ''
              : i > 0 && strArr[i] === 0 && strArr[i - 1] === 0
              ? ''
              : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i])) + newNum
        }
        return newNum
      }
      return getWan(num)
    }
  },
  /* eslint-disable */
  created() {
    // console.log(typeof(this.groupCarList.itemList))
    // this.groCarList = this.groupCarList.filter((item) => {
    //   if (!item.activityTag) {
    //     return false
    //   } else {
    //     return true
    //   }
    // })
    this.now = Date.parse(new Date())
    this.filterActivity()
    // this.groupCarList.itemList.map((item, index) => {
    //   // item.ladderDtoList = activityInfoDtos.ladderDtoList
    //   item.joinNumber = 3
    //   if (item.activityItemInfoDto && item.activityItemInfoDto.activityInfoDto) {
    //     item.startTime = item.activityItemInfoDto.activityInfoDto.startTime
    //     item.endTime = item.activityItemInfoDto.activityInfoDto.endTime
    //   }
    //   // this.groupCar.push(item)
    //   this.$set(this.groCarList, index, item)
    //   return item
    // })
  }
}
</script>

<style lang="scss" scoped>
.onlyProductImage {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: auto;
    height: 138px;
  }
}
.date-red {
  color: #c6001f;
  margin-right: 4px;
}
.person-red {
  color: #c6001f;
  margin-right: 4px;
}
.content-bottom {
  width: 100%;
  // height: 102px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .group-num {
    font-size: 14px;
    font-weight: 400;
    color: #6c6c6c;
    line-height: 20px;
  }
  .grounp-btn {
    width: 220px;
    height: 40px;
    background: #d20c33;
    box-shadow: 0px 1px 0px 0px #e0e0e1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 18px;
  }
}
.progress-bar {
  width: 100%;
  height: 108px;
  box-sizing: border-box;
  margin-top: 10px;
  .progress-text {
    width: 75px;
  }
  .progress-text-begin {
    width: 75px;
    color: #252525;
  }
  .progress-text:nth-of-type(2) {
    display: inline-block;
    width: 57px;
    // text-align: center;
  }
  .progress-text:last-of-type {
    text-align: right;
  }
  .progress-top {
    font-size: 16px;
    color: #d20c33;
    display: flex;
    justify-content: space-between;
    line-height: 24px;
  }
  .progress-center {
    margin: 7px 0px;
    position: relative;
    width: 100%;
    height: auto;
    .white-line {
      width: 2px;
      height: 12px;
      position: absolute;
      background-color: #fff;
      left: 50%;
      top: 50%;
      margin: -6px 0 0 -2px;
    }
  }
  .progress-bottom {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: #6c6c6c;
    line-height: 24px;
  }
}
.groupMain {
  margin: 0 auto;
  width: 1360px;

  .title {
    // padding-top: 40px;
    // margin: 0 0 25px;
    // font-size: 22px;
    // font-family: NotoSansHans-Bold;
    // font-weight: bold;
    // color: #000;
    width: 100%;
    font-size: 22px;
    font-family: 'NotoSansHans-Bold';
    font-weight: bold;
    margin-bottom: 25px;
    padding-top: 40px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
}

.groupLogo {
  width: 143px;
  height: 28px;
  margin-top: 60px;
}

.groupCar {
  width: 1360px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;

  .groupList {
    // margin-top: 30px;
    box-sizing: border-box;
    width: 443px;
    min-height: 350px;
    padding: 26px 36px 20px;
    background: rgba(255, 255, 255, 1);
    transition: all 0.2s linear;
    position: relative;
    margin-right: 15px;
    margin-bottom: 15px;
    .group-info:hover {
      cursor: pointer;
    }

    .onePush {
      font-size: 16px;
      color: rgba(102, 102, 102, 1);
      line-height: 44px;

      span {
        color: #eb5342;
        font-size: 16px;
      }

      button {
        float: right;
        width: 137px;
        height: 44px;
        background: linear-gradient(45deg, rgba(239, 93, 66, 1) 0%, rgba(218, 31, 70, 1) 100%);
        box-shadow: 0px 1px 0px 0px rgba(224, 224, 225, 1);
        border-radius: 24px;
        border: 0;
        font-size: 18px;
        color: rgba(255, 255, 255, 1);
        cursor: pointer;
      }
    }

    .groupName {
      font-size: 18px;
      font-weight: 500;
      color: rgba(57, 60, 81, 1);
      line-height: 25px;

      span {
        display: inline-block;
        // width:34px;
        height: 23px;
        line-height: 23px;
        padding: 0 4px;
        background: rgba(218, 30, 70, 1);
        border-radius: 2px;
        color: #fff;
        font-size: 13px;
        text-align: center;
        margin-right: 12px;
      }
    }
  }

  .groupList:nth-of-type(3n) {
    margin-right: 0;
  }
  .groupList:hover {
    top: -3px;
    box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, 0.22);
  }
  .img {
    width: 245px;
    height: 138px;
    top: 51px;
    margin: 9px auto;
    display: flex;
    justify-content: center;
    img {
      width: auto;
      height: 100%;
    }
  }
}
</style>
